export default function () {
  return {packageProperties: {engines: {node: '>=12.20'}}};
}
